<template>
  <main class="l-main">
    <div class="main-box">
      <div class="title">
        Welcome, <em>KSI.</em><br>
        Choose a game mode.
      </div>
      <div class="control">
        <router-link v-bind:to="{name: 'Factory'}" class="control__btn" id="btn-mode-factory">
          <img :src="`${staticPath}img/mode/btn_factory.png`" alt="factory">
        </router-link>
        <router-link v-bind:to="{name: 'Factory', params: {isModeStudy: true}}" class="control__btn" id="btn-mode-study">
          <img :src="`${staticPath}img/mode/btn_study.png`" alt="study">
        </router-link>
      </div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/mode.scss';
</style>

<script>
  import Constant from '@/constant';

  export default {

    data() {
      return {
        staticPath: Constant.STATICPATH
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/PageMode.vue